
export const faqCategories = [
  { id: 'booking', label: '예약 관련', icon: 'ri-calendar-check-line' },
  { id: 'tour', label: '투어 진행', icon: 'ri-compass-3-line' },
  { id: 'payment', label: '결제 / 환불', icon: 'ri-money-dollar-circle-line' },
  { id: 'preparation', label: '여행 준비', icon: 'ri-luggage-cart-line' },
  { id: 'safety', label: '안전 / 기타', icon: 'ri-shield-check-line' },
];

export const faqItems = [
  {
    id: 1,
    category: 'booking',
    question: '투어 예약은 어떻게 하나요?',
    answer: '홈페이지의 각 투어 상세 페이지에서 날짜와 인원을 선택한 후 예약 양식을 작성하시면 됩니다. 카카오톡(@bonggutour)으로도 예약이 가능하며, 24시간 내에 확정 안내를 드립니다.',
  },
  {
    id: 2,
    category: 'booking',
    question: '예약 확정은 언제 되나요?',
    answer: '예약 신청 후 24시간 이내에 카카오톡 또는 이메일로 확정 안내를 드립니다. 성수기(12월~2월)에는 최소 3일 전 예약을 권장드립니다.',
  },
  {
    id: 3,
    category: 'booking',
    question: '예약 후 날짜 변경이 가능한가요?',
    answer: '투어 출발 48시간 전까지 무료로 날짜 변경이 가능합니다. 48시간 이내 변경 시 변경 수수료(투어 금액의 10%)가 발생할 수 있습니다. 카카오톡으로 변경 요청을 보내주세요.',
  },
  {
    id: 4,
    category: 'booking',
    question: '최소 예약 인원이 있나요?',
    answer: '대부분의 투어는 1인부터 예약 가능합니다. 다만, 프라이빗 투어의 경우 최소 2인 이상 예약이 필요하며, 1인 참가 시 추가 요금이 발생할 수 있습니다.',
  },
  {
    id: 5,
    category: 'tour',
    question: '투어에 한국어 가이드가 동행하나요?',
    answer: '네, 봉구 투어의 모든 투어에는 한국어가 가능한 전문 가이드가 동행합니다. 현지 문화와 역사에 대한 풍부한 설명과 함께 안전하게 투어를 진행합니다.',
  },
  {
    id: 6,
    category: 'tour',
    question: '호텔 픽업/드롭 서비스가 포함되어 있나요?',
    answer: '네, 세부 시티 및 막탄 지역 호텔은 무료 픽업/드롭 서비스가 포함되어 있습니다. 그 외 지역(릴로안, 코르도바 등)은 추가 교통비가 발생할 수 있으니 예약 시 호텔 위치를 알려주세요.',
  },
  {
    id: 7,
    category: 'tour',
    question: '투어 중 식사는 어떻게 되나요?',
    answer: '대부분의 투어에 점심 식사가 포함되어 있습니다. 필리핀 현지 음식 또는 해산물 바비큐가 제공되며, 채식이나 알레르기가 있으신 경우 사전에 말씀해 주시면 별도 준비해 드립니다.',
  },
  {
    id: 8,
    category: 'tour',
    question: '비가 오면 투어가 취소되나요?',
    answer: '가벼운 비는 투어 진행에 큰 영향이 없습니다. 다만, 태풍이나 폭풍 등 기상 악화 시에는 안전을 위해 투어가 취소되며, 이 경우 전액 환불 또는 날짜 변경이 가능합니다.',
  },
  {
    id: 9,
    category: 'payment',
    question: '결제 방법은 어떤 것이 있나요?',
    answer: '카카오페이, 계좌이체(한국 은행), 현지 페소 현금 결제가 가능합니다. 신용카드 결제는 현재 준비 중이며, 곧 지원 예정입니다.',
  },
  {
    id: 10,
    category: 'payment',
    question: '취소 시 환불 규정은 어떻게 되나요?',
    answer: '투어 출발 72시간 전 취소 시 전액 환불, 48~72시간 전 취소 시 70% 환불, 24~48시간 전 취소 시 50% 환불됩니다. 24시간 이내 취소 또는 노쇼(No-show)의 경우 환불이 불가합니다.',
  },
  {
    id: 11,
    category: 'payment',
    question: '환불은 얼마나 걸리나요?',
    answer: '환불 승인 후 영업일 기준 3~5일 이내에 처리됩니다. 계좌이체의 경우 1~2일, 카카오페이의 경우 즉시~3일 이내에 환불됩니다.',
  },
  {
    id: 12,
    category: 'preparation',
    question: '투어 시 무엇을 준비해야 하나요?',
    answer: '수영복, 여벌 옷, 선크림(산호초 보호를 위해 리프세이프 제품 권장), 수건, 방수 가방을 준비해 주세요. 스노클링 장비와 구명조끼는 저희가 제공합니다.',
  },
  {
    id: 13,
    category: 'preparation',
    question: '아이와 함께 참여할 수 있나요?',
    answer: '대부분의 투어는 만 4세 이상부터 참여 가능합니다. 나루수안 아일랜드, 선셋 크루즈 등은 가족 친화적인 투어로 특히 추천드립니다. 캐녀닝 투어는 만 12세 이상부터 참여 가능합니다.',
  },
  {
    id: 14,
    category: 'preparation',
    question: '수영을 못해도 참여할 수 있나요?',
    answer: '네, 구명조끼를 착용하므로 수영을 못하셔도 안전하게 스노클링을 즐기실 수 있습니다. 가이드가 항상 옆에서 도와드리니 걱정하지 마세요.',
  },
  {
    id: 15,
    category: 'safety',
    question: '투어 중 안전 관리는 어떻게 하나요?',
    answer: '모든 투어에 응급처치 자격증을 보유한 가이드가 동행하며, 구명조끼와 안전 장비를 필수로 착용합니다. 보트에는 GPS와 통신 장비가 구비되어 있으며, 현지 해양경찰과 비상 연락 체계를 갖추고 있습니다.',
  },
  {
    id: 16,
    category: 'safety',
    question: '여행자 보험이 포함되어 있나요?',
    answer: '기본 투어에는 여행자 보험이 포함되어 있지 않습니다. 별도의 여행자 보험 가입을 권장드리며, 필요하시면 보험 가입 안내를 도와드립니다.',
  },
  {
    id: 17,
    category: 'safety',
    question: '긴급 상황 시 연락처는 어디인가요?',
    answer: '긴급 연락처: +63 917 123 4567 (24시간 운영). 카카오톡 @bonggutour으로도 긴급 연락이 가능합니다. 현지 응급 번호는 911입니다.',
  },
];
